import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Box 2.0",
  type: "rh/components/content/box2",
  isContainer: true,
  config: {
    emptyLabel: "Box 2.0",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
